import z from 'zod';
export const TABLE_ID_REGEX = /^[a-z0-9][a-z0-9-]{0,79}$/;
const columnFilterSchema = z.object({
    id: z.string().min(1).max(100),
    value: z.unknown(),
});
const columnSortSchema = z.object({
    id: z.string().min(1).max(100),
    desc: z.boolean(),
});
export const tableSettingsStateSchema = z.object({
    columnFilters: z.array(columnFilterSchema).max(50),
    sorting: z.array(columnSortSchema).max(10),
    search: z.string().max(500),
});
export const updateTableSettingsSchema = z.object({
    state: tableSettingsStateSchema,
    commiteeId: z.number().int().positive().nullable().optional(),
});
export const tableSettingsQuerySchema = z.object({
    commiteeId: z.coerce.number().int().positive().optional(),
});
